import React from "react";

/** Hairline rule with an optional centred glyph — the brand's section separator. */
export function Ornament({ variant = "rule", glyph = "◆", width = 180, tone = "default", style }) {
  const line = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 35%, transparent)" : "var(--rule)";
  const mark = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 80%, transparent)" : "var(--accent)";
  if (variant === "flourish") {
    const foil = `linear-gradient(90deg, transparent, ${tone === "onDark" ? "var(--accent)" : "var(--accent)"} 24%, var(--gold-300) 50%, var(--accent) 76%, transparent)`;
    return (
      <div style={{ display: "grid", justifyItems: "center", gap: 5, width: "100%", maxWidth: width, margin: "0 auto", ...style }}>
        <span style={{ width: "100%", height: 1, background: foil, opacity: 0.9 }} />
        <span style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
          <span style={{ flex: 1, height: 1, background: foil, opacity: 0.45 }} />
          <span style={{ width: 5, height: 5, background: "var(--accent)", transform: "rotate(45deg)", flex: "none" }} />
          <span style={{ flex: 1, height: 1, background: foil, opacity: 0.45 }} />
        </span>
      </div>
    );
  }
  if (variant === "dot") {
    return (
      <div style={{ display: "flex", gap: 8, justifyContent: "center", alignItems: "center", ...style }}>
        {[0, 1, 2].map((i) => (
          <span key={i} style={{ width: i === 1 ? 5 : 3, height: i === 1 ? 5 : 3, borderRadius: "50%", background: mark, opacity: i === 1 ? 1 : 0.5 }} />
        ))}
      </div>
    );
  }
  if (variant === "vertical") {
    return <div style={{ width: 1, height: 64, background: line, margin: "0 auto", ...style }} />;
  }
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "var(--sp-3)", width: "100%", maxWidth: width, margin: "0 auto", ...style }}>
      <span style={{ flex: 1, height: 1, background: line }} />
      {variant === "glyph" && <span style={{ color: mark, fontSize: 9, letterSpacing: "0.2em" }}>{glyph}</span>}
      <span style={{ flex: 1, height: 1, background: line }} />
    </div>
  );
}
